/**
 * Global UMD Version for tools
 * Version: woolive_1.0.1
 */
;(function (global, factory) {
  // 确保 global 对象存在
  var root = (typeof self !== 'undefined' ? self : 
              typeof window !== 'undefined' ? window : 
              typeof global !== 'undefined' ? global : {});

  if (typeof define === 'function' && define.amd) {
    // AMD 模块规范
    define([], function () {
      return factory(root);
    });
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS 模块规范
    module.exports = factory(root);
  } else {
    // 浏览器全局变量
    root.WOOLIVE = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (root) {

  // Hosts
  var HOST = {
    API: 'https://wapi.woolive.tv',
    DEV: 'https://wapi-test.woolive.tv',
    TEST: 'https://wapi-test.woolive.tv'
  }

  function isNode() {
    return typeof process !== 'undefined' &&
      process.versions != null &&
      process.versions.node != null
  }

  // in nodejs
  if (isNode()) {
    // window = root
    window = {
      addEventListener: () => { }
    }
  }
  // in browser
  else {
    console.log(window.navigator.userAgent)
  }

  // Returns data object in app
  window.WOOLIVE_JS_CALLBACK = function (data) {
    console.warn('callback in app ==>', data)
  }

  window.addEventListener('load', () => {
    console.log('GET TOKEN LOAD =>', window.WOOLIVE_USER_TOKEN)
  })

  // Channel type
  // ===============
  // push      1 // in app event
  // APP-end   2 // app webview
  // PC-end    3 // pc end
  // other-end 4 // other
  var loggerList = []

  // get platform from useragent
  var getPlatform = function () {
    // useragent
    var userAgent = navigator.userAgent

    // ios
    if (/iP(hone|od|ad)/.test(userAgent)) {
      // iOS device
      var iosVersionMatch = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)
      console.log('ios version =>', iosVersionMatch && iosVersionMatch[0])
      return 'IOS'
    }
    // Android device
    else if (/Android/.test(userAgent)) {
      var androidVersionMatch = userAgent.match(/Android (\d+).(\d+)/)
      console.log('android version =>', androidVersionMatch)
      return 'Android'
    }
    // default browser
    else {
      console.log('Not an iOS or Android device')
    }
  }

  // second to HMS
  var second2HMS = function (time) {
    var d = parseInt(time, 10)
    var h = Math.floor(d / 3600)
    var m = Math.floor(d % 3600 / 60)
    var s = Math.floor(d % 3600 % 60)
    function format(num) {
      var val = 0
      if (num > 0) {
        if (num >= 10) {
          val = num
        } else {
          val = '0' + num
        }
      }
      else {
        val = '00'
      }
      return val
    }
    var hr = format(h)
    var min = format(m)
    var sec = format(s)
    var hms = hr + ':' + min + ':' + sec
    return hms
  }

  // count down times
  const timeToSliceSecond = (second) => {
    var time = {}
    if (second > 0) {
      var mss = second
      var days = parseInt(mss / (1000 * 60 * 60 * 24))
      var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = parseInt((mss % (1000 * 60)) / 1000)
      time = {
        day: days < 10 ? "0" + days : days,
        hour: hours < 10 ? "0" + hours : hours,
        minute: minutes < 10 ? "0" + minutes : minutes,
        second: seconds < 10 ? "0" + seconds : seconds,
        mss: mss,
      }
    } else {
      time = {
        day: '00',
        hour: '00',
        minute: '00',
        second: '00',
        mss: 0,
      }
    }
    return time
  }

  // count down times
  const countDown = (endTimeStamp) => {
    var nowTimeStamp = new Date().getTime()
    if (endTimeStamp > nowTimeStamp) {
      var mss = endTimeStamp - nowTimeStamp
      return timeToSliceSecond(mss)
    } else {
      return timeToSliceSecond(0)
    }
  }

  var listenObj = {}

  var abbrNum = function (number, decPlaces) {
    decPlaces = Math.pow(10, decPlaces)
    var abbrev = ["k", "m", "b", "t"]
    for (var i = abbrev.length - 1; i >= 0; i--) {
      var size = Math.pow(10, (i + 1) * 3)
      if (size <= number) {
        number = Math.round(number * decPlaces / size) / decPlaces
        if ((number == 1000) && (i < abbrev.length - 1)) {
          number = 1
          i++
        }
        number += abbrev[i]
        break
      }
    }
    return number
  }

  function formatNumber(num) {
    if (!num) return 0
    if (num >= 1e6) {
        return (num / 1e6).toFixed(0) + 'M';
    } else if (num >= 1e3) {
        return (num / 1e3).toFixed(0) + 'K';
    }
    return num.toString();
  }

  function isValidIPv4(ip) {
    const parts = ip.split('.')
    if (parts.length !== 4) {
      return false
    }
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      if (isNaN(part) || part < 0 || part > 255 || part.indexOf(' ') >= 0) {
        return false
      }
    }
    return true
  }

  // get api host
  var getHost = function (MODE) {
    if (MODE === 'API' || MODE === "DEV") {
      return HOST[MODE]
    }
    let whiteListDev = ['www-test.woolive.tv']
    let whiteListTest = ['127.0.0.1', 'localhost']
    if (whiteListDev.includes(window.location.hostname) || isValidIPv4(window.location.hostname)) {
      return HOST.DEV
    } else if (whiteListTest.includes(window.location.hostname)) {
      return HOST.TEST
    } else {
      return HOST.API
    }
  }

  // app-call-js
  var APP_CALL_JS = function (event, payload) {
    if (listenObj[event]) {
      listenObj[event] && listenObj[event](payload)
    }
  }

  // Listener event in apps
  var appToJsListener = function (event, callback) {
    if (event && callback) {
      listenObj[event] = callback
    }
  }

  // Get url path
  var getParams = function (key, type) {
    const reg = new RegExp(key + '=(.+?)(&|\\?|#|$|\/)')
    let regRs = location.href.match(reg)
    if (regRs && regRs.length > 0) {
      let target = regRs[1].replace(key + '=', '')
      if (type === 'number') {
        return Number(target)
      } else {
        return target
      }
    } else {
      return regRs
    }
  }

  // get channel
  var getChannel = function (channelType) {
    let channel = getParams('channel')
    if (!channelType || !channel) {
      console.warn('ChannelType error!')
      return false
    }
    logEvent('h5_' + channelType + '_' + channel)
  }

  // get hash token
  var getHashToken = function () {
    let token = location.href.match(/[^#]+(?=$)/)
    if (token && token.length > 0) {
      return token[0]
    } else {
      return false
    }
  }

  // open app
  var OPEN_APP =  function () {
    location.href = `woolive://tv.woolive.live/main`
  }

  // Interact in Woolive webview
  var WOOLIVE_APP_ACTION = function (key, params, callback) {
    var AndroidObj = window.WOOLIVE_ANDROID_INTERACTION
    var IOSObject = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.WOOLIVE_IOS
    console.log('App in =>', getPlatform())
    if (getPlatform() === 'IOS' && IOSObject) {
      let obj = {
        method: key,
        params: params || ''
      }
      IOSObject.postMessage(JSON.stringify(obj))
    }
    if (getPlatform() === 'Android' && AndroidObj) {
      return AndroidObj.doAction(key, params || '')
    } else {
      console.warn('Not in WOOLIVE App!', key, params)
      return null
    }
  }

  // Interact in Android webview
  var AndroidWebviewAction = function (key, params) {
    var androidObj = window.WOOLIVE_ANDROID_INTERACTION
    if (androidObj) {
      return androidObj.doAction(key, params || '')
    } else {
      console.warn('Not in woolive android Webview!', key, params)
      return null
    }
  }

  var getJsonInfo = function (key) {
    try {
      var resData = AndroidWebviewAction(key || '', 1)
      if (typeof resData === 'string') {
        return window.JSON.parse(resData)
      } else {
        return null
      }
    } catch (err) {
      return null
    }
  }

  // Get UserData in wooliveApp
  var getUserInfoByNative = function () {
    try {
      var userData = AndroidWebviewAction('getUserData', 1)
      if (typeof userData === 'string') {
        return window.JSON.parse(userData)
      } else {
        return null
      }
    } catch (err) {
      return null
    }
  }

  // Is In WooliveApp
  var isInApp = function () {
    return window.WOOLIVE_ANDROID_INTERACTION || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.WOOLIVE_IOS
  }

  // Get attrs
  var getAttr = function (dom, key) {
    if (dom && dom.getAttribute)
      return dom.getAttribute(key) || ''
  }

  // getToken
  var getToken = function () {
    if (window.WOOLIVE_USER_TOKEN) {
      return window.WOOLIVE_USER_TOKEN
    }
    else if (getUserInfoByNative() && getUserInfoByNative()['userToken']) {
      return getUserInfoByNative()['userToken']
    }
    else if (getParams('token')) {
      return getParams('token')
    }
    else {
      console.log('Get Token Fail...')
      return null
    }
  }

  // getter StatusBar Height
  var getBarHeight = function () {
    return getJsonInfo('getStatusBarHeight')
  }

  // logger events
  var logEvent = function (key, data) {
    if (window.__wooGa) {
      window.__wooGa.logEvent(key, data || null)
    } else {
      loggerList.push({
        key: key,
        data: data ? data : null
      })
    }
  }

  // Binding btn in native
  window.addEventListener('DOMContentLoaded', function (e) {
    document.body.addEventListener('click', function (e) {
      var target = e.target
      if (!target) return
      if (target.nodeName !== 'BUTTON') {
        target = e.target.parentNode
      }
      var flag = getAttr(target, 'data-target'),
        targetKey = getAttr(target, 'data-key'),
        targetParam = getAttr(target, 'data-param')
      if (flag === 'woolive') {
        AndroidWebviewAction(targetKey, targetParam)
        logEvent('woolive_active_event', { data: targetParam })
      }
    }, false)

    var script = document.createElement('script')
    script.src = '/global/js/woo-ga-1.0.1.js'
    document.body.appendChild(script)
    script.addEventListener('load', function () {
      if (window.wooliveGa) {
        var ga = window.wooliveGa
        window.__wooGa = new ga()
        if (loggerList && loggerList.length > 0) {
          loggerList.forEach(function (item) {
            if (item) {
              logEvent(item.key, item.data)
            }
          })
        }
      }
    })
  }, false)

  var pullDownToExecute = function (callback) {
    // Pulldown to Refresh
    let isWithinBottomRange = false
    let timeoutId = null

    function checkScrollPosition() {
      const scrollPosition = window.scrollY + window.innerHeight
      const bottomPosition = document.documentElement.scrollHeight - 100

      if (scrollPosition >= bottomPosition) {
        if (!isWithinBottomRange) {
          isWithinBottomRange = true
          timeoutId = setTimeout(() => {
            refreshPage()
          }, 250)
        }
      } else {
        if (isWithinBottomRange) {
          clearTimeout(timeoutId)
          isWithinBottomRange = false
        }
      }
    }

    function refreshPage() {
      // location.reload()
      console.log('pull down to execute....')
      callback && callback()
    }

    // listen scroll event
    window.addEventListener('scroll', checkScrollPosition)
  }

  // export
  return {
    HOST: HOST,
    pullDownToExecute: pullDownToExecute,
    second2HMS: second2HMS,
    countDownHMS: countDown,
    isInApp: isInApp,
    APP_CALL_JS: APP_CALL_JS,
    appToJsListener: appToJsListener,
    getParams: getParams,
    getToken: getToken,
    logEvent: logEvent,
    getHost: getHost,
    getChannel: getChannel,
    abbrNum: abbrNum,
    getUserInfo: getUserInfoByNative,
    getHashToken: getHashToken,
    getBarHeight: getBarHeight,
    getPlatform: getPlatform,
    OPEN_APP,
    formatNumber: formatNumber,
    timeToSliceSecond: timeToSliceSecond,
    AndroidWebviewAction: AndroidWebviewAction,
    WOOLIVE_APP_ACTION: WOOLIVE_APP_ACTION
  }
}))
